import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import {
  EmptyState,
  Loading,
  TableTitle,
  LinkBack
} from 'components/common/Elements/Elements';

import TableWidget from './parts/TableWidget/TableWidget';

import { getRequest } from 'utils/requests';

import classes from './Dpc.module.scss';

const Dpc = ({ customerId }) => {
  // //data from api
  const [data, setData] = useState([]);

  // //other data
  const [loader, setLoader] = useState(true);
  const [dataConection, setDataConection] = useState(false);

  // const [triggerSaveTableSettings, setTriggerSaveTableSettings] =
  //   useState(false);

  const tableHeight = useRef();
  const unmount = useRef(false);

  useEffect(() => {
    return () => {
      unmount.current = true;
    };
  }, []);

  useEffect(() => {
    requestForFilteredData();
    // eslint-disable-next-line
  }, []);

  const requestForFilteredData = () => {
    const linkForRequest = `/customer/platform/dpc/list?customerId=${customerId}`;

    getRequest(linkForRequest)
      .then(res => {
        if (!unmount.current) {
          setData(res.body);
          setDataConection(true);
          setLoader(false);
        }
      })
      .catch(err => {
        if (!unmount.current) {
          setDataConection(false);
          setLoader(false);
          console.log(err);
        }
      });
  };

  if (loader) {
    return <Loading />;
  }

  if (!dataConection) {
    return <EmptyState message="connect" />;
  }

  return (
    <>
      <div className={classes.header}>
        <TableTitle
          className={classes.titleCounter}
          title={'Device Posture Check Policies'}
          additional={data.length}
          withWordResult={false}
        />
        <LinkBack text="Platform" />
      </div>
      <div>
        <div ref={tableHeight}>
          <TableWidget data={data} />
        </div>
      </div>
    </>
  );
};

Dpc.propTypes = {
  customerId: PropTypes.string
};

export default Dpc;
